export const NoData = () => {
  return (
    <div class="alert alert-danger mt-4" role="alert">
      No Data Found...!!
    </div>
  );
};
